module.exports = __webpack_public_path__ + "img/table-sorting.deb652bc.svg";